import {
  AUTH_REDIRECT_URI_STORAGE_KEY,
  IDLE_LOGOUT_TIME_MS,
} from "@/constants";
import { authSignOutRedirect } from "@/provider/AuthProvider/signOut";
import { useFeatureFlags } from "@/context/FeatureFlags";
import { useIdle } from "@uidotdev/usehooks";
import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";

export default function useIdleLogout() {
  const { features } = useFeatureFlags();
  const idle = useIdle(IDLE_LOGOUT_TIME_MS);
  const auth = useAuth();

  const [open, setOpen] = useState(false);

  if (idle && !open) {
    setOpen(true);
  }

  useEffect(() => {
    const logout = async () => {
      sessionStorage.setItem(
        AUTH_REDIRECT_URI_STORAGE_KEY,
        `${window.location.pathname}${window.location.search}${window.location.hash}`
      );
      await authSignOutRedirect(auth.signoutRedirect, {
        post_logout_redirect_uri: `${window.location.origin}/logout`,
        state: {
          reason: "idle",
        },
      });
    };

    if (open && features.IDLE_TIMEOUT) {
      logout();
    }
  }, [auth, open, features]);
}
